// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1cmJO","footer":"ModalFilter_footer__2XmkO"};